export const environment = {
  production: true,
  // Empty string → Socket.io connects to the same origin that serves the app.
  // The NestJS server serves the built SPA, so client and server share a domain
  // (works on any prod/staging domain without rebuilding).
  wsUrl: '',
};
